import { cn } from "@/lib/utils";
import { AGENDA_KINDS, agendaKey } from "@/lib/agendaColors";

export const AgendaLegend = ({ items }) => {
  const present = new Set((items || []).map(agendaKey));
  return (
    <ul className="mb-4 flex flex-wrap gap-x-4 gap-y-1.5" data-testid="agenda-legend">
      {AGENDA_KINDS.map((k) => (
        <li key={k.key} className={cn("flex items-center gap-1.5 text-xs transition-opacity", present.has(k.key) ? "text-slate-600" : "text-slate-400 opacity-60")}
          data-testid={`agenda-legend-${k.key}`}>
          <span className={cn("h-2.5 w-2.5 rounded-sm", k.dot)} />{k.label}
        </li>
      ))}
    </ul>
  );
};
